import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  Output
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { HttpEventType } from '@angular/common/http';
import { IMessengerConnector } from '../../../types/all.type';
import {InterfaceService} from '../../../services/interface.service';
declare const navigator: any;
declare const MediaRecorder: any;
@Component({
  selector: 'app-voice',
  templateUrl: './voice.component.html',
  styleUrls: ['./voice.component.scss']
})
export class VoiceComponent implements AfterViewInit {
  @Output() onSendVoice = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  @Input() Service: IMessengerConnector;
  file: any;
  isRecording = true;
  isPlaying = false;
  error = '';
  isSending = false;
  constructor(
    public interfaceService: InterfaceService,
    private cd: ChangeDetectorRef,
    private dom: DomSanitizer,
    private zone: NgZone,
    public notifierWrapService: NotifierWrapService
  ) {}
  stop() {
    // alert('stop')
  }
  start() {
    // alert('start')
  }
  ngAfterViewInit() {
    const _this = this;
    ('use strict');
    /**
     * @author: Sam Bellen
     * @description: Draw a waveform from the microphone's audio.
     *               Tested in Chrome and Firefox.
     */
    (() => {
      // Set all variables which needed the audio stream
      const setAudioStream = (stream) => {
        stream = stream;
        input = audioContext.createMediaStreamSource(stream);
        recorder = new MediaRecorder(stream);
        setRecorderActions();
        setupWaveform();
      };
      // Setup the recorder actions
      const setRecorderActions = () => {
        recorder.ondataavailable = saveChunkToRecording;
        recorder.onstop = saveRecording;
      };
      // Show a message in the UI
      if (!AudioContext) {
        _this.error =
          'Возможно ваш браузер не поддерживает запись с микрофона, проверьте права доступа к микрофону в браузере.';
        this.cd.detectChanges();
      }
      // UI Elements
      const canvas: any = document.querySelector('.js-canvas');
      const recordButton: any = document.querySelector('.js-record');
      const sendButton: any = document.querySelector('.js-send');
      const playButton: any = document.querySelector('.js-play');
      const audioPlayer: any = document.querySelector('.js-audio');
      // Constants
      const audioContext: any = new AudioContext();
      const analyser: any = audioContext.createAnalyser();
      const scriptProcessor: any = audioContext.createScriptProcessor(2048, 1, 1);
      const chunks = [];
      // Variables
      const stream = null;
      let input = null;
      let recorder = null;
      let recording = null;
      // Setup analyser node
      analyser.smoothingTimeConstant = 0.3;
      analyser.fftSize = 1024;
      // Canvas variables
      const barWidth = 2;
      const barGutter = 2;
      const barColor = '#ffffff';
      let canvasContext = canvas.getContext('2d');
      let bars = [];
      let width = 0;
      let height = 0;
      let halfHeight = 0;
      let drawing = false;
      // Request access to the user's microphone.
      const requestMicrophoneAccess = () => {
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia({ audio: true }).then(
            function (stream) {
              setAudioStream(stream);
              startRecording();
            },
            (error) => {
              _this.error =
                'Нет доступа к микрофону, включите его настройках (удерживать иконку приложения -> о приложении)';
              this.cd.detectChanges();
            }
          );
        } else {
          _this.error = 'Нет разрешения на запись, проверьте права доступа к микрофону в браузере.';
          this.cd.detectChanges();
        }
      };
      // Save chunks of the incomming audio to the chuncks array
      const saveChunkToRecording = (event) => {
        chunks.push(event.data);
      };
      // Save the recording
      const saveRecording = () => {
        recording = URL.createObjectURL(new Blob(chunks, { type: 'audio/ogg; codecs=opus' }));
        _this.file = new File(chunks, 'voice.ogg', { type: 'audio/ogg; codecs=opus' });
        //_this.sendVoice();
        [];
        audioPlayer.setAttribute('src', recording);
        playButton.classList.remove('button--disabled');
      };
      // Start recording
      const startRecording = () => {
        _this.isRecording = true;
        recordButton.classList.add('btn-circle-load');
        recorder.start();
        _this.start();
        _this.cd.detectChanges();
      };
      // Stop recording
      const stopRecording = () => {
        _this.isRecording = false;
        recordButton.classList.remove('btn-circle-load');
        recorder.stop();
        _this.stop();
        _this.cd.detectChanges();
      };
      // Toggle the recording button
      const toggleRecording = () => {
        if (_this.isRecording) {
          stopRecording();
        } else {
          startRecording();
        }
      };
      // Setup the canvas to draw the waveform
      const setupWaveform = () => {
        canvasContext = canvas.getContext('2d');
        width = canvas.offsetWidth;
        height = canvas.offsetHeight;
        halfHeight = canvas.offsetHeight / 2;
        canvasContext.canvas.width = width;
        canvasContext.canvas.height = height;
        input.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(audioContext.destination);
        scriptProcessor.onaudioprocess = processInput;
      };
      // Process the microphone input
      const processInput = (audioProcessingEvent) => {
        if (_this.isRecording) {
          const array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          bars.push(getAverageVolume(array));
          if (bars.length <= Math.floor(width / (barWidth + barGutter))) {
            renderBars(bars);
          } else {
            renderBars(bars.slice(bars.length - Math.floor(width / (barWidth + barGutter))));
          }
        } else {
          bars = [];
        }
      };
      // Calculate the average volume
      const getAverageVolume = (array) => {
        const length = array.length;
        let values = 0;
        let i = 0;
        for (; i < length; i++) {
          values += array[i];
        }
        return values / length;
      };
      // Render the bars
      const renderBars = (bars) => {
        if (!drawing) {
          drawing = true;
          window.requestAnimationFrame(() => {
            canvasContext.clearRect(0, 0, width, height);
            bars.forEach(function (bar, index) {
              canvasContext.fillStyle = barColor;
              canvasContext.fillRect(index * (barWidth + barGutter), halfHeight, barWidth, halfHeight * (bar / 100));
              canvasContext.fillRect(
                index * (barWidth + barGutter),
                halfHeight - halfHeight * (bar / 100),
                barWidth,
                halfHeight * (bar / 100)
              );
            });
            drawing = false;
          });
        }
      };
      // Play the recording
      const play = () => {
        _this.isPlaying = true;
        audioPlayer.play();
        playButton.classList.add('button--active');
      };
      // Stop the recording
      const stop = () => {
        _this.isPlaying = false;
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
        playButton.classList.remove('button--active');
      };
      // Toggle the play button
      const togglePlay = () => {
        if (_this.isPlaying) {
          stop();
        } else {
          play();
        }
      };
      // Setup the audio player
      const setupPlayer = () => {
        this.zone.runOutsideAngular(() => {
          audioPlayer.addEventListener('ended', () => {
            stop();
          });
        });
      };
      // Start the application
      requestMicrophoneAccess();
      setupPlayer();
      // Add event listeners to the buttons
      this.zone.runOutsideAngular(() => {
        recordButton.addEventListener('mouseup', toggleRecording);
        sendButton.addEventListener('mouseup', toggleRecording);
        playButton.addEventListener('mouseup', togglePlay);
      });
    })();
  }

  sendVoice() {
    this.isSending = true;
    setTimeout(() => {
      this.Service.sendVoice(this.file, this.Service.openChat.id).subscribe(
        (resp: any) => {
          if (resp.type === HttpEventType.Response) {
            console.log('Upload complete');
            this.cd.detectChanges();
            this.onSendVoice.emit(resp);
            this.cancel();
          }
          if (resp.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round((100 * resp.loaded) / resp.total);
            console.log('Progress ' + percentDone + '%');
          }
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    }, 250);
  }
  cancel() {
    this.isSending = false;
    this.onClose.emit(true);
  }
}
